
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/layout/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-green-50">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">The PEO App, Inc. — Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none text-gray-600">
            <p className="text-lg font-semibold mb-8">Effective Date: April 28, 2025</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
              <p>The PEO App, Inc. ("Company," "we," "our," "us") respects your privacy and is committed to protecting it. This Privacy Policy explains how we collect, use, and share your information when you use our Services.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Information We Collect</h2>
              <p>We collect information you voluntarily provide, including:</p>
              <ul className="list-disc pl-6 mt-2">
                <li>Company information (legal name, address, NAICS code, EIN, employee counts, payroll systems)</li>
                <li>Contact information (name, email, phone number)</li>
                <li>Sensitive data (payroll data, benefits information, claims history, regulatory status)</li>
                <li>Login and account credentials</li>
              </ul>
              <p className="mt-4">We also collect certain technical information automatically (such as IP address, device type, and browser).</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul className="list-disc pl-6">
                <li>Facilitate PEO matching and quoting services</li>
                <li>Communicate with you about your application</li>
                <li>Improve our platform and offerings</li>
                <li>Manage broker partnerships and control authorized access</li>
                <li>Offer optional premium services</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. How We Share Your Information</h2>
              <p>We may share your information with:</p>
              <ul className="list-disc pl-6 mt-2 mb-4">
                <li>Selected PEO providers for the purpose of generating quotes</li>
                <li>A broker if you voluntarily use their invitation link or enter their private access code</li>
                <li>Trusted service providers assisting with hosting, CRM, security, or communications</li>
                <li>Regulatory authorities when legally required</li>
              </ul>
              <p>We do not sell your personal information.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Data Security</h2>
              <p>We use HIPAA-compliant and SOC 2-audited infrastructure to protect your information. However, while we secure data using industry best practices, no method of transmission or storage is completely secure.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Your Choices</h2>
              <p>You may request access, corrections, or deletion of your personal information by contacting us at <a href="mailto:info@thepeoapp.com" className="text-primary hover:underline">info@thepeoapp.com</a>. You may opt out of marketing communications at any time.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Children's Privacy</h2>
              <p>Our Services are intended for users 18 years or older. We do not knowingly collect information from minors.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Changes to This Policy</h2>
              <p>We may update this Privacy Policy from time to time. Updates will be posted with a new effective date. Continued use of the Services after changes constitutes acceptance of the updated policy.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Contact</h2>
              <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@thepeoapp.com" className="text-primary hover:underline">info@thepeoapp.com</a>.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
